import { fromJS, List } from 'immutable';

import {
  // TaskSchedule
  LOAD_TASKS_SUCCESS,
  LOAD_BOARD_TASKS_SUCCESS,
  RESET_BOARD_TASKS,
  LOAD_TASK_BY_ID_SUCCESS,
  LOAD_TASK_SCHEDULE_SUCCESS,
  UPDATE_TASK_SCHEDULE_SUCCESS,
  DELETE_TASK_SCHEDULE_SUCCESS,
  LOAD_SCHEDULE_TASKS_SUCCESS,
  LOAD_TASK_LIST_SUCCESS,
  // EventSchedule
  LOAD_EVENT_SCHEDULES_SUCCESS,
  LOAD_EVENT_SUCCESS,
  LOAD_EVENTS_SUCCESS,
  LOAD_EVENT_SCHEDULE_SUCCESS,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_SCHEDULE_SUCCESS,
  DELETE_EVENT_SCHEDULE_SUCCESS,
} from '../../constants/ActionTypes';
import { normalizeEntities } from '../../helpers/utilHelpers';

const initialState = fromJS({});

const scheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TASK_LIST_SUCCESS:
    case LOAD_BOARD_TASKS_SUCCESS:
    case LOAD_TASKS_SUCCESS: {
      const schedules = [];
      action.tasks.items.forEach((task) => {
        if (task.schedule) {
          schedules.push({ ...task.schedule });
        }
      });

      return normalizeEntities(schedules, 'scheduleId', state);
    }
    case LOAD_EVENTS_SUCCESS: {
      const schedules = [];
      action.events.items.forEach((event) => {
        if (event.schedule) {
          schedules.push({ ...event.schedule });
        }
      });

      return normalizeEntities(schedules, 'scheduleId', state);
    }
    case LOAD_EVENT_SUCCESS:
    case UPDATE_EVENT_SUCCESS: {
      return action.event.schedule ? state.set(action.event.schedule.scheduleId, fromJS(action.event.schedule)) : state;
    }
    case LOAD_TASK_BY_ID_SUCCESS: {
      const schedule = action.task.schedule;
      return schedule ? state.set(schedule.scheduleId, fromJS(schedule)) : state;
    }
    case LOAD_EVENT_SCHEDULES_SUCCESS:
    case LOAD_TASK_SCHEDULE_SUCCESS: {
      return normalizeEntities(action.schedules.items, 'scheduleId', state);
    }
    case UPDATE_EVENT_SCHEDULE_SUCCESS:
    case LOAD_EVENT_SCHEDULE_SUCCESS:
    case UPDATE_TASK_SCHEDULE_SUCCESS: {
      return state.set(action.schedule.scheduleId, fromJS(action.schedule));
    }
    case DELETE_EVENT_SCHEDULE_SUCCESS:
    case DELETE_TASK_SCHEDULE_SUCCESS: {
      return state.delete(action.entityId);
    }
    case LOAD_SCHEDULE_TASKS_SUCCESS: {
      let items = state.getIn([action.scheduleId, 'tasks', 'items'], new List());
      action.tasks.items.forEach((task) => {
        if (!items.includes(task.taskId)) {
          items = items.push(task.taskId);
        }
      });

      const currentPage = state.getIn([action.scheduleId, 'tasks', 'pagination', 'currentPage']);

      const pagination = {
        currentPage: currentPage > action.tasks._meta.currentPage ? currentPage : action.tasks._meta.currentPage,
        pageCount: action.tasks._meta.pageCount,
      };

      return state.setIn([action.scheduleId, 'tasks'], fromJS({ items, pagination }));
    }
    case RESET_BOARD_TASKS: {
      return initialState;
    }
    default:
      return state;
  }
};

export default scheduleReducer;
